// src/pages/Reports/ItemProfitLoss/itemProfitLossThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getItemWiseReportApi } from "../../../apiservice/reports";

export const fetchItemProfitLoss = createAsyncThunk(
  "itemProfitLoss/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const payload = {};

      // ✅ Only include dates if "Date Wise"
      if (filters.filterType === "Date Wise") {
        if (filters.fromDate) payload.fromDate = filters.fromDate;
        if (filters.toDate) payload.toDate = filters.toDate;
      }

      // ✅ Add filters based on Record Type
      switch (filters.type) {
        case "Item Wise":
          payload.itemId = filters.itemId || null;
          break;
        case "Group Wise":
          payload.groupId = filters.groupId || null;
          break;
        case "Category Wise":
          payload.categoryId = filters.categoryId || null;
          break;
        case "Warehouse Wise":
          payload.warehouseId = filters.warehouseId || null;
          break;
        default:
          // "All Item Stock" → no extra filter
          break;
      }

      const res = await getItemWiseReportApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error fetching data");
    }
  }
);
